import { render, staticRenderFns } from "./sendGoodsDialog.vue?vue&type=template&id=f9c96e82"
import script from "./sendGoodsDialog.vue?vue&type=script&lang=js"
export * from "./sendGoodsDialog.vue?vue&type=script&lang=js"
import style0 from "./sendGoodsDialog.vue?vue&type=style&index=0&id=f9c96e82&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports